import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UnauthorisedComponent } from './shared/components/unauthorised/unauthorised.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  {
    path: 'dashboard',
    loadChildren: () => import('./modules/document/document-module').then((m) => m.DocumentModule),
    canActivate: [MsalGuard],
  },

  { path: 'unauthorized', component: UnauthorisedComponent },

  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
